import * as angular from 'angular';

"use strict";
angular.module('complianceService', []);

export default 'complianceService'
